// removed by extract-text-webpack-plugin
module.exports = {"LoginBox":"MXI-e_K_w6dDZU_69nga6","LoginBox__title":"dMb2c8FVvvC_OhxMwhQo3","LoginBox__form":"_3CfYoNoferbXZHl3qqjEmS","LoginBox__form-input":"CGfJbHKo-5QBX9t2pqEFt","LoginBox__signin-button":"_1JMnfX23AcLc_s0fOIy_JC","LoginBox__error":"_8TPmsqVzY4J7NcVp0C8E2","LoginBox__form-error":"_1FeJ97hE9itAa-gbXY-tE2","LoginBox__forgot-box":"_3NjoAv-FPAph4VdMC6A17F","LoginBox__forgot-link":"_18YzXx2XrY7-n6OAw6MNBg","loginWithEpicButtonWrap":"_28_quL6nMQfoY5sWTUqU9t","overlay":"htiVv-a-G8VPeQBRgIBwf","wrap":"_3Hugj-HoCW1E1izoSMVepA","preloader":"_2sYBfGWphkDORwQWEKkY_r","label":"_3UV6cErRxKyX4yBGMW_Qbe"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LoginWithEpic/LoginWithEpic.scss
// module id = 2898
// module chunks = 0